export enum PropertyStatus {
  CREATE_LISTING = "CREATE_LISTING",
  PHOTOS_AND_VIDEO = "PHOTOS_AND_VIDEO",
  DOCUSIGN_SIGNING = "DOCUSIGN_SIGNING",
  UPLOAD_DOCUMENTS = "UPLOAD_DOCUMENTS",
  CREATE_CALENDAR_BLOCK = "CREATE_CALENDAR_BLOCK",
  PENDING_ACTION = "PENDING_ACTION",
  REVIEWING = "REVIEWING",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  ARCHIVED = "ARCHIVED",
  NON_RENTING = "NON_RENTING",
}

export enum PropertyType {
  SINGLE_FAMILY_HOME = "SINGLE_FAMILY_HOME",
  TOWNHOUSE = "TOWNHOUSE",
  CONDOMINIUM = "CONDOMINIUM",
  DUPLEX = "DUPLEX",
}

export enum ActivityType {
  NEW_PROPERTY = "New Property",
  NEW_CALENDAR_BLOCK = "New Calendar Block",
  LISTING_EDIT_REQUEST = "Listing Edit Request",
  NEW_MESSAGE = "New Message",
}

// Display categories for calendar blocks (mapped from database ReservationTypeMapping)
export enum CalendarBlockType {
  OWNER_BLOCK = "OWNER_BLOCK",
  BOOKING = "BOOKING",
  OTHER = "OTHER",
  PREVIOUS_BOOKING = "PREVIOUS_BOOKING", // Used for hidden types
}

export enum SigningSessionState {
  IDLE = "idle",
  LOADING = "loading",
  SIGNING = "signing",
}

export enum DocusignEnvelopeStatus {
  NOT_STARTED = "NOT_STARTED",
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
  VOIDED = "VOIDED",
}

export enum SmartLockType {
  INTEGRATION = "integration",
  STATIC_PIN = "staticPin",
  LAST_FOUR_DIGITS = "lastFourDigits",
}
